import React, { Component, PropTypes } from 'react';
import { Field, FieldArray } from 'redux-form';
import { TextInputField, TextAreaField, RadioButtonField } from 'common/components/form_fields';
import ParticipantsField from 'presentations/components/participants_field';
import ParticipantMsgPreview from 'presentations/containers/participant_msg_preview';

export default class AddStepParticipants extends Component {
  constructor(props) {
    super(props);

    this.state = { showingMsgPreview: false };
    this.toggleMsgPreview = this.toggleMsgPreview.bind(this);
  }

  toggleMsgPreview() {
    this.setState({ showingMsgPreview: !this.state.showingMsgPreview });
  }

  render() {
    const { weightVotes } = this.props;
    const { showingMsgPreview } = this.state;

    return (
      <div className="step-participants">
        <fieldset>
          <h3>Weight Votes</h3>
          <p>Do you want some participants' votes count more than others?</p>
          <Field name="weight_votes" component={RadioButtonField}
            props={{ value: true }}
            label="Yes, use weighted votes."
          />
          <Field name="weight_votes" component={RadioButtonField}
            props={{ value: false }}
            label="No, all votes should be equal."
          />
        </fieldset>
        <fieldset>
          <h3>Your Name</h3>
          <p>Let the people you invite to your presentation know who you are.</p>
          <div className="row name-row">
            <div className="columns small-16 medium-8">
              <Field name="first_name" label="First Name" component={TextInputField} />
            </div>
            <div className="columns small-16 medium-8">
              <Field name="last_name" label="Last Name" component={TextInputField} />
            </div>
          </div>
        </fieldset>
        <fieldset>
          <h3>Participant Email</h3>
          <p>
            You will be able to add more participants anytime after you launch your
            presentation site. We will not share this email with anyone.
          </p>
          <FieldArray name="participants" component={ParticipantsField} props={{ weightVotes }} />
        </fieldset>
        <fieldset>
          <h3>Personal Message</h3>
          <p>
            We'll include this message in the invitation email we send to each participant.<br/>
            You can <a onClick={this.toggleMsgPreview}>preview the invitation</a> to see
            what your invitees will receive.
          </p>
          <Field name="invite_message" component={TextAreaField} rows={5} />
        </fieldset>
        <ParticipantMsgPreview showing={showingMsgPreview} onClose={this.toggleMsgPreview} />
      </div>
    );
  }
}

AddStepParticipants.propTypes = {
  weightVotes: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./presentations/components/add_step_participants.jsx